// import React, { useEffect, useRef } from "react";
// import "./Smallbar.css";
// import stat from "./stat.png";
// import Chart from "chart.js/auto";

// const Smallbar = (data) => {
//   const chartRef = useRef(null);

//   useEffect(() => {
//     const data = {
//       labels: ["1", "2", "3", "4", "5", "6"],
//       datasets: [
//         {
//           label: "Data",
//           data: [80, 60, 90, 70, 50, 60],
//           backgroundColor: "#e4c748",
//           borderColor: "#e4c748",
//           borderWidth: 0.5,
//           borderRadius: 20,
//         },
//       ],
//     };

//     const options = {
//       responsive: true,
//       maintainAspectRatio: false,
//       scales: {
//         y: {
//           display: false, // Hide y-axis
//         },
//       },
//       plugins: {
//         legend: {
//           display: false, // Hide legend
//         },
//       },
//       indexAxis: "x", // Display bars horizontally
//       barPercentage: 0.2, // Adjust bar width to fill the entire width of the canvas
//       categoryPercentage: 1, // Adjust space between bars
//     };

//     const ctx = chartRef.current;
//     if (ctx) {
//       // Destroy existing chart if it exists
//       if (ctx.chart) {
//         ctx.chart.destroy();
//       }

//       // Create new chart
//       ctx.chart = new Chart(ctx, {
//         type: "bar",
//         data: data,
//         options: options,
//       });
//     }
//   }, []);

//   return (
//     <div className="smallbargraph">
//       <div className="barhed">
//         <h2 className="lefty">Weekly Revenue</h2>
//         <div className="right">
//           {" "}
//           <img src={stat} alt="" />
//         </div>
//       </div>
//       <div className="bargrph" style={{ width: "100%", height: "150px" }}>
//         <canvas ref={chartRef}></canvas>
//       </div>
//     </div>
//   );
// };

// export default Smallbar;

import React, { useEffect, useRef } from "react";
import "./Smallbar.css";
import stat from "./stat.png";
import Chart from "chart.js/auto";

const Smallbar = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!data || data.length === 0) return;

    const chartData = {
      labels: data.map((_, i) => `W${i + 1}`), // e.g., W1, W2, W3...
      datasets: [
        {
          label: "New Users",
          data: data,
          backgroundColor: "#e4c748",
          borderColor: "#e4c748",
          borderWidth: 0.5,
          borderRadius: 20,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        y: {
          display: false, // Hide y-axis
        },
      },
      plugins: {
        legend: {
          display: false, // Hide legend
        },
      },
      indexAxis: "x",
      barPercentage: 0.2,
      categoryPercentage: 1,
    };

    const ctx = chartRef.current;
    if (ctx) {
      // Destroy previous chart instance
      if (ctx.chart) {
        ctx.chart.destroy();
      }

      ctx.chart = new Chart(ctx, {
        type: "bar",
        data: chartData,
        options: options,
      });
    }
  }, [data]);

  return (
    <div className="smallbargraph">
      <div className="barhed">
        <h2 className="lefty">New Users (Last 6 Weeks)</h2>
        <div className="right">
          <img src={stat} alt="stat icon" />
        </div>
      </div>
      <div className="bargrph" style={{ width: "100%", height: "150px" }}>
        <canvas ref={chartRef}></canvas>
      </div>
    </div>
  );
};

export default Smallbar;
